import React, { useState } from "react";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import { PROD_LINK, STAGING_LINK } from "../../constant";
import { IS_STAGING } from "../../constant/api";
import Merchants from "./Merchants";
import MercahntLogs from "./MercahntLogs";
import CustomerLogs from "./CustomerLogs";
import Customerkyc from "./Customerkyc";
const KycLogs = () => {
  const [merchantDeet, setMerchantDeet] = useState<any[]>([]);
  const [customerDeet, setCustomerDeet] = useState<any[]>([]);
  const [openLog, setOpenLog] = useState<boolean>(false);
  const [openCustomerLog, setOpenCustomerLog] = useState<boolean>(false);
  const [taskScreen, setTaskScreen] = useState<number>(1);
  const [refetch, setRefetch] = useState<number>(1);
  const [kyc3Refetch, setKyc3Refetch] = useState<number>(1);

  return (
    <div className="w-full h-screen flex flex-col overflow-hidden">
      <div className="w-full h-[31px] shrink-0 bg-[#1B1B1B] flex justify-center items-center">
        {IS_STAGING ? (
          <h4 className="font-medium text-[#AEBCC6] text-[12px]">
            You are in Staging:{" "}
            <span>
              <a href={PROD_LINK} className="text-[#03C668]">
                Switch to Prod
              </a>
            </span>
          </h4>
        ) : (
          <h4 className="font-medium text-[#AEBCC6] text-[12px]">
            You are in PROD:{" "}
            <span>
              <a href={STAGING_LINK} className="text-[#DF4E4E]">
                Switch to Staging
              </a>
            </span>
          </h4>
        )}
      </div>
      <div className="flex flex-1 min-h-0 w-full flex-col lgss:flex-row overflow-hidden">
        <Sidebar />
        <div className="w-full lgss:w-10/12 flex-1 min-h-0 min-w-0 overflow-y-auto bg-[#13181B]">
          <Navbar />

          <div className="w-full px-5 h-full pt-8 mds:px-12 font-manrope lgss:px-10  bg-[#13181B]">
            {openLog ? (
              <MercahntLogs
                setOpenLog={setOpenLog}
                merchantDeet={merchantDeet}
                setRefetch={setRefetch}
              />
            ) : openCustomerLog ? (
              <Customerkyc
                setRefetch={setKyc3Refetch}
                customerDeet={customerDeet}
                setOpenCustomerLog={setOpenCustomerLog}
              />
            ) : (
              <>
                <div className="flex justify-start items-center lgss:justify-between lgss:gap-0 lgss:w-full">
                  <div className="flex  justify-start items-center lgss:w-2/5 px-4 gap-8  bg-transparent  rounded-lg w-full h-[50px]">
                    <button
                      onClick={() => setTaskScreen(1)}
                      className={
                        taskScreen === 1
                          ? "text-white font-semibold text-[12px] uppercase"
                          : "text-[#333F48] font-semibold text-[12px] uppercase"
                      }
                    >
                      Customers
                    </button>
                    <button
                      onClick={() => setTaskScreen(2)}
                      className={
                        taskScreen === 2
                          ? "text-white font-semibold text-[12px] uppercase"
                          : "text-[#333F48] font-semibold text-[12px] uppercase"
                      }
                    >
                      Business
                    </button>
                  </div>
                </div>
                {taskScreen === 2 ? (
                  <Merchants
                    setOpenLog={setOpenLog}
                    refetch={refetch}
                    setMerchantDeet={setMerchantDeet}
                  />
                ) : taskScreen === 1 ? (
                  <CustomerLogs
                    setOpenCustomerLog={setOpenCustomerLog}
                    refetch={kyc3Refetch}
                    setCustomerDeet={setCustomerDeet}
                  />
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KycLogs;
